"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _compose = _interopRequireDefault(require("./compose"));

var _default = (0, _compose["default"])(JSON.parse, JSON.stringify);

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9jbG9uZS1qc29uLnRzIl0sIm5hbWVzIjpbIkpTT04iLCJwYXJzZSIsInN0cmluZ2lmeSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O2VBRWUseUJBQ2JBLElBQUksQ0FBQ0MsS0FEUSxFQUViRCxJQUFJLENBQUNFLFNBRlEsQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjb21wb3NlIGZyb20gXCIuL2NvbXBvc2VcIjtcblxuZXhwb3J0IGRlZmF1bHQgY29tcG9zZShcbiAgSlNPTi5wYXJzZSxcbiAgSlNPTi5zdHJpbmdpZnlcbik7XG4iXX0=